import React, { useState } from 'react';
import { getPlaceholderImage } from '../utils/helpers';

const ImageWithFallback = ({ 
  src, 
  alt, 
  fallbackSrc = null,
  className = "", 
  width = 400, 
  height = 300,
  ...props 
}) => {
  const [imgSrc, setImgSrc] = useState(src);
  const [hasError, setHasError] = useState(false);

  const handleError = () => {
    if (!hasError) {
      setHasError(true);
      // Use fallbackSrc if provided, otherwise use placeholder
      const fallback = fallbackSrc || getPlaceholderImage(width, height);
      setImgSrc(fallback);
    }
  };

  return (
    <img
      src={imgSrc}
      alt={alt}
      className={className}
      onError={handleError}
      {...props}
    />
  );
};

export default ImageWithFallback;
